import React from 'react';
import PropTypes from 'prop-types';

import { ContentCopyOutlined } from '@mui/icons-material';

import {
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from '@mui/material';

import {
  bodyRowSx,
  headCellSx
} from '../../../../../Common/components/Listing/styles';

import {
  actionCellSx,
  copyButtonSx,
  emptyCellSx,
  emptyTextSx,
  tableBodyCellSx,
  tableContainerSx,
  tableSx
} from './VSHxStyles';

const VSHxTable = ({
  rows,
  columns,
  onCopy
}) => {
  return (
    <TableContainer sx={tableContainerSx}>
      <Table stickyHeader size="small" sx={tableSx}>
        <TableHead>
          <TableRow>
            {columns.map(column => (
              <TableCell
                key={column.field}
                align={column.align || 'left'}
                sx={headCellSx}>
                {column.headerName}
              </TableCell>
            ))}

            <TableCell
              align="center"
              sx={{ ...headCellSx, width: 90 }}>
              ACTIONS
            </TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {rows.map(row => (
            <TableRow
              key={row.id}
              hover
              sx={bodyRowSx}>
              {columns.map(column => (
                <TableCell
                  key={column.field}
                  align={column.align || 'left'}
                  sx={tableBodyCellSx}>
                  {row[column.field]}
                </TableCell>
              ))}

              <TableCell
                align="center"
                sx={actionCellSx}>
                <IconButton
                  aria-label={`Copy vital signs from ${row.date}`}
                  size="small"
                  onClick={() => onCopy(row)}
                  sx={copyButtonSx}>
                  <ContentCopyOutlined sx={{ fontSize: 18 }} />
                </IconButton>
              </TableCell>
            </TableRow>
          ))}

          {!rows.length && (
            <TableRow>
              <TableCell
                colSpan={columns.length + 1}
                align="center"
                sx={emptyCellSx}>
                <Typography sx={emptyTextSx}>
                  No vital sign history found.
                </Typography>
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

VSHxTable.propTypes = {
  rows: PropTypes.array.isRequired,
  columns: PropTypes.array.isRequired,
  onCopy: PropTypes.func.isRequired
};

export default VSHxTable;